import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import Icon from 'mdi-react/NotePlusOutlineIcon';
import Tooltip from '@material-ui/core/Tooltip';

const SendButton = (props) => {
  const { influencer } = props;
  return (
    <span>
      <Tooltip title="Send Agreement">
        <Link to={`/send-agreement/${influencer.id}`}>
          <button className="MuiButtonBase-root MuiIconButton-root material-table__toolbar-button MuiIconButton-sizeSmall">
            <Icon style={{ width: '15px', height: '15px' }} />
          </button>
        </Link>
      </Tooltip>
    </span>
  );
};

SendButton.propTypes = {
  influencer: PropTypes.objectOf(PropTypes.any).isRequired,
};

export default SendButton;
